import React, { useState, useRef, useEffect, useMemo } from "react";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { editInvestment, deleteInvestmentTranch, getAllConsolApi } from "../../../../WorkSpace/Components/ApiServices/apiHandler";
import { Button } from "../../../../myfin_v2/elements/Button";
import { getProjects } from "../../../../Console/Component/services/apiHandler";
import buttoncss from "../../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../../myfin_v2/css/investmentRegister.module.css";
import { ReactComponent as LeftArrowIcon } from "../../../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon }        from "../../../../myfin_v2/assets/icons/dot.svg";
import { ReactComponent as CalenderIcon }   from "../../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as DownArrow }      from "../../../../myfin_v2/assets/icons/down-arrow.svg";
import ArrowCircle from "../../../../myfin_v2/assets/icons/ArrowCircle.png";
import WarningIcon from  "../../../../myfin_v2/assets/icons/warningIcon.png";
import rupeeIcon from "../../../../myfin_v2/assets/icons/Rupee.png";
import { getLinkedCompanies, GetAllCompanyData, getInvestmentRegisterForms } from "../../../../WorkSpace/Components/ApiServices/apiHandler";
import ConsolEntryConfigModal from "../components/InvestmentForms/ConsolEntryConfigModal";
import { ReactComponent as PlusIcon } from "../../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as RemoveIcon } from "../../../../myfin_v2/assets/icons/removeLoansIcons.svg";
import { useLocation, useHistory } from "react-router-dom";
import CommonDatePicker from "../../../../myfin_v2/elements/CommonDatePicker";
import DeletePopup from "../../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../../myfin_v2/elements/ErrorPopup";

const statusStyles = {
  Investment: { bg: "#E8FEFF", color: "#42778B", border: "#CAE6E6" },
  "Associate Company": { bg: "#FDF5E9", color: "#A7683E", border: "#EDE3D8" },
  Associate: { bg: "#FDF5E9", color: "#A7683E", border: "#EDE3D8" },
  Subsidiary: { bg: "#F0EBFD", color: "#564AC5", border: "#D4D1E3" },
  "Joint Venture": { bg: "#F6FDE7", color: "#778F41", border: "#DAEAAE" }
};

const formatIndianNumber = (val) => {
  if (val == null) return "";
  const num = Number(val);
  if (isNaN(num)) return String(val);

  if (num < 0) {
    return "(" + (-1 * num).toLocaleString("en-IN") + ")";
  }
  return num.toLocaleString("en-IN");
};

const NATURE_OPTIONS = [
  { value: "Purchase of Shares",                label: "Purchase of Shares" },
  { value: "Sale of Shares to Third Party",     label: "Sale of Shares to Third Party" },
  // { value: "Buyback by Investee from Investor", label: "Buyback by Investee from Investor" },
  // { value: "Subscription to Rights Issue",      label: "Subscription to Rights Issue" },
  // { value: "Stock Split by Investee",           label: "Stock Split by Investee" },
  // { value: "Bonus Issue by Investee",           label: "Bonus Issue by Investee" },
];

const CLASS_OF_SHARE_OPTIONS = [
  { value: "Equity",          label: "Equity" },
  { value: "Preference",      label: "Preference" },
  { value: "Right Issue",     label: "Right Issue" },
  { value: "Lease Liability", label: "Lease Liability" },
];

const COST_BASIS_OPTIONS = [
  { value: "FIFO",         label: "FIFO" },
  { value: "LIFO",         label: "LIFO" },
  { value: "Average Cost", label: "Average Cost" },
];

const RELATIONSHIP_OPTIONS = [
  { value: "Investment", label: "Investment" },
  { value: "Subsidiary", label: "Subsidiary" },
  { value: "Associate",  label: "Associate" },
  { value: "Joint Venture", label: "Joint Venture" },
];


const CustomDropdown = ({ label, options, value, onChange, placeholder, fullWidth, fallbackLabel }) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const ref = useRef(null);

  const selected = (options || []).find((o) => o.value === value || o.label === value);

  useEffect(() => {
      setActiveIndex(-1);
  }, [search, open]);

  const handleKeyDown = (e) => {
      if (!open && (e.key === "ArrowDown" || e.key === "ArrowUp")) {
          setOpen(true);
          return;
      }
      if (e.key === "ArrowDown") {
          e.preventDefault();
          setActiveIndex(prev => (prev < filteredOptions.length - 1 ? prev + 1 : prev));
      } else if (e.key === "ArrowUp") {
          e.preventDefault();
          setActiveIndex(prev => (prev > 0 ? prev - 1 : prev));
      } else if (e.key === "Enter") {
          e.preventDefault();
          if (open && activeIndex >= 0 && activeIndex < filteredOptions.length) {
              const opt = filteredOptions[activeIndex];
              onChange(opt.value);
              setSearch(opt.label);
              setOpen(false);
          }
      }
  };

  useEffect(() => {
      if (selected) {
          setSearch(selected.label);
      } else if (value) {
          setSearch(value);
      } else if (fallbackLabel) {
          setSearch(fallbackLabel);
      } else {
          setSearch("");
      }
  }, [value, options, selected, fallbackLabel]);

  useEffect(() => {
    const close = (e) => { 
        if (ref.current && !ref.current.contains(e.target)) {
            setOpen(false); 
            if (selected) {
                setSearch(selected.label);
            } else if (value) {
                setSearch(value);
            } else if (fallbackLabel) {
                setSearch(fallbackLabel);
            }
        }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [selected, value, fallbackLabel]);

  const list = options || [];
  let filteredOptions = list;
  if (!(selected && search === selected.label) && !(fallbackLabel && search === fallbackLabel) && search && search.trim()) {
    filteredOptions = list.filter((opt) =>
      String(opt.label || "").toLowerCase().includes(search.toLowerCase())
    );
  }

  const handleInputChange = (e) => {
      const val = e.target.value;
      setSearch(val);
      setOpen(true);
      const matched = (options || []).find(
          (o) => o.label.toLowerCase() === val.toLowerCase() || String(o.value).toLowerCase() === val.toLowerCase()
      );
      if (matched) {
          onChange(matched.value);
      } else {
          onChange(val);
      }
  };

  return (
    <div style={{ flex: fullWidth ? undefined : 1, width: fullWidth ? "100%" : undefined }}>
      {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
      <div ref={ref} style={{ position: "relative" }}>
        <div className={investmentRegisterCss.dropdownField} onClick={() => setOpen((p) => !p)} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <input
              className={investmentRegisterCss.input}
              style={{ 
                  border: "none", 
                  padding: 0, 
                  height: "auto", 
                  flex: 1, 
                  color: selected && search === selected.label ? "#205a46" : "#111", 
                  fontSize: "14px",
                  backgroundColor: "transparent",
                  outline: "none"
              }}
              value={search}
              placeholder={placeholder || "Select"}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
          />
          <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.2 }} className={investmentRegisterCss.chevron} onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
            <DownArrow width={18} height={18} />
          </motion.span>
        </div>
        {open && (
          <div className={investmentRegisterCss.dropdownMenuScrollable} style={{ zIndex: 999 }}>
            {filteredOptions.length > 0 ? filteredOptions.map((opt, i) => (
              <div
                key={i}
                className={`${investmentRegisterCss.dropdownItem} ${opt.value === value || activeIndex === i ? investmentRegisterCss.dropdownItemActive : ""}`}
                style={activeIndex === i ? { backgroundColor: "#f4faf5", color: "#2d8861" } : {}}
                onClick={() => { 
                    onChange(opt.value); 
                    setSearch(opt.label);
                    setOpen(false); 
                }}
              >
                {opt.label}
              </div>
            )) : (
              <div className={investmentRegisterCss.dropdownItem} style={{ color: "#b3c0bd" }}>No options found</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const TextInput = ({ label, placeholder, value, onChange, readOnly }) => (
  <div style={{ flex: 1 }}>
    {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
    <input
      className={investmentRegisterCss.input}
      placeholder={placeholder}
      value={value || ""}
      onChange={(e) => onChange && onChange(e.target.value)}
      readOnly={readOnly}
    />
  </div>
);

const AmountInput = ({ label, placeholder, value, onChange }) => (
  <div style={{ flex: 1 }}>
    {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
    <div className={investmentRegisterCss.inputWrapper}>
      <input
        className={investmentRegisterCss.input}
        placeholder={placeholder || "Enter Amount"}
        value={value || ""}
        onChange={(e) => onChange && onChange(e.target.value)}
        style={{ paddingRight: "36px" }}
      />
      <span className={investmentRegisterCss.iconRight}>
        <img src={rupeeIcon} alt="₹" className={investmentRegisterCss.rupeeIcon} />
      </span>
    </div>
  </div>
);

export const DateInput = ({ label, value, onChange, placement = "bottom" }) => {
    const validDate = value ? (typeof value === 'string' && value.match(/^\d{2}-\d{2}-\d{4}$/) ? new Date(value.split('-').reverse().join('-')) : new Date(value)) : null;
    return (
        <div style={{ flex: 1 }}>
            {label && <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>{label}</label>}
            <CommonDatePicker
                value={validDate}
                onChange={(newVal) => onChange && onChange(newVal ? dayjs(newVal).format("DD-MM-YYYY") : "")}
                containerClass={investmentRegisterCss.inputWrapper}
                inputClass={investmentRegisterCss.input}
                iconStyle={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)" }}
                placement={placement}
            />
        </div>
    );
};


const Section = ({ children }) => (
  <div style={{
    background: "#fff", border: "1px solid #EAEEED", borderRadius: "14px",
    padding: "24px 28px", marginBottom: "16px",
    display: "flex", flexDirection: "column", gap: "20px",
  }}>
    {children}
  </div>
);

const Row = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", alignItems: "start" }}>
    {children}
  </div>
);

const Row2 = ({ children }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", alignItems: "start" }}>
    {children}
  </div>
);


const HoldingStatus = ({
  prevShares,
  prevOwnership,
  currentShares,
  currentOwnership,
  sharesDiff,
  percentDiff,
  relationship
}) => {

  const getRelationshipLabel = (ownership) => {
    const percent = Number(ownership);
    if (percent > 50) return "Subsidiary";
    if (percent === 50) return "Joint Venture";
    if (percent > 20 && percent < 50) return "Associate";
    return "Investment";
  };

  const label = getRelationshipLabel(currentOwnership);
  const style = statusStyles[label] || statusStyles["Investment"];
  const isShareNegative = sharesDiff < 0;
  const isPercentNegative = percentDiff < 0;

  const shareColor = isShareNegative ? "#ff0000" : "#349F6F";
  const shareBg = isShareNegative ? "#FDECEC" : "#E6F5EC";
  const shareBorder = isShareNegative ? "#F5C2C2" : "#C2E6D1";

  const percentColor = isPercentNegative ? "#ff0000" : "#349F6F";
  const percentBg = isPercentNegative ? "#FDECEC" : "#E6F5EC";
  const percentBorder = isPercentNegative ? "#F5C2C2" : "#C2E6D1";

  const prevStatus = getRelationshipLabel(prevOwnership);
  const currStatus = getRelationshipLabel(currentOwnership);
  const isStatusChanged = prevStatus !== currStatus;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #EAEEED",
        borderRadius: "14px",
        padding: "24px 28px",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          marginLeft: "-28px",
          marginRight: "-28px",
          paddingLeft: "28px",
          paddingRight: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
          paddingBottom: "16px",
          borderBottom: "1px solid #EAEEED",
        }}
      >
        <span style={{ fontSize: "18px", fontWeight: "500", color: "#111" }}>
          Holding & status
        </span>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span style={{ fontSize: "13px", color: "#66827A" }}>
            Current Status
          </span>

          <span
            style={{
              background: style.bg,
              color: style.color,
              border: `1px solid ${style.border}`,
              padding: "4px 14px",
              borderRadius: "20px",
              fontSize: "13px",
              fontWeight: "700",
              letterSpacing: "0.04em",
            }}
          >
            {label.toUpperCase()}
          </span>
        </div>
      </div>

      <div
        style={{
          padding: "18px 20px",
          marginBottom: "20px",
          display: "flex",
          alignItems: "flex-start",
          gap: "14px",
        }}
      >
        <img src={WarningIcon} alt="icon" width="35" height="35" />

        <div>
          <div
            style={{
              fontSize: "20px",
              fontWeight: "300",
              color: "#111",
              marginBottom: "4px",
            }}
          >
            {isStatusChanged
              ? `Status Changed! You're now ${label === "Associate" || label === "Investment" ? "an" : "a"} ${label}`
              : `Holding Status: ${label}`}
          </div>

          <div style={{ fontSize: "15px", color: "#66827A" }}>
            {currStatus === "Subsidiary"
              ? "Your ownership crossed 50% granting subsidiary control rights"
              : currStatus === "Associate"
              ? "Your ownership crossed 20% granting significant influence as an Associate"
              : currStatus === "Joint Venture"
              ? "Your ownership reached 50% granting joint control rights"
              : `Ownership changed to ${currentOwnership}%`}
          </div>
        </div>
      </div>

      <div
        style={{
          marginLeft: "-28px",
          marginRight: "-28px",
          paddingLeft: "28px",
          paddingRight: "28px",
          paddingTop: "20px",
          paddingBottom: "20px",
          borderTop: "1px solid #eaeeed",
          display: "flex",
          alignItems: "center",
          gap: "40px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px",
            marginLeft: "25px",
          }}
        >
          <span
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#8FAAA3",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
            }}
          >
            BEFORE
          </span>

          <span
            style={{
              fontSize: "26px",
              fontWeight: "500",
              color: "#131B19",
              lineHeight: 1,
            }}
          >
            {prevShares}
          </span>

          <span style={{ fontSize: "16px", color: "#349F6F", fontWeight: "600" }}>
            {prevOwnership}% Ownership
          </span>
        </div>

        <img src={ArrowCircle} alt="arrow" width="45" height="45" />

        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <span
            style={{
              fontSize: "12px",
              fontWeight: "600",
              color: "#8FAAA3",
              letterSpacing: "1.5px",
              textTransform: "uppercase",
            }}
          >
            NOW
          </span>

          <div style={{ display: "flex", alignItems: "baseline", gap: "10px" }}>
            <span
              style={{
                fontSize: "26px",
                fontWeight: "500",
                color: "#131B19",
                lineHeight: 1,
              }}
            >
              {currentShares}
            </span>

            <span
              style={{
                background: shareBg,
                color: shareColor,
                border: `1px solid ${shareBorder}`,
                borderRadius: "20px",
                padding: "2px 10px",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              {sharesDiff > 0 ? `+${sharesDiff}` : sharesDiff}
            </span>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                fontSize: "16px",
                color: percentColor,
                fontWeight: "600",
              }}
            >
              {currentOwnership}% Ownership
            </span>

             <span
                style={{
                  background: percentBg,
                  color: percentColor,
                  border: `1px solid ${percentBorder}`,
                  borderRadius: "20px",
                  padding: "2px 8px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                {percentDiff > 0 ? `+${percentDiff}%` : `${percentDiff}%`}
              </span>
          </div>
        </div>
      </div>
    </div>
  );
};


// AdditionalInfo 
const AdditionalInfo = ({ formData, onChange, projectOptions, consolList }) => {
  const seedFields = (formData?.addOtherDetails || []).map((d, i) => ({
    id:         i + 1,
    fieldLabel: d.description || "",
    amount:     d.amount != null ? String(d.amount) : "",
  }));

  const consolData = formData?.consolEntry || {};
  const translatedConsolData = formData?.translatedConsolEntry || {};

  const [otherFields, setOtherFields] = useState(
    seedFields.length > 0
      ? seedFields
      : [{ id: 1, fieldLabel: "", amount: "" }]
  );

  const [showConfigModal, setShowConfigModal] = useState(false);
  const [showConsoleEntry, setShowConsoleEntry] = useState(() => {
    const hasData = [
      consolData?.nciValue, consolData?.nonControllingAsset,
      consolData?.investment, consolData?.consolInvestment,
      consolData?.goodWill, consolData?.otherInputs,
      consolData?.netAssets, consolData?.gainOnBargainPurchase
    ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
    return hasData || false;
  });

  useEffect(() => {
    const hasData = [
      consolData?.nciValue, consolData?.nonControllingAsset,
      consolData?.investment, consolData?.consolInvestment,
      consolData?.goodWill, consolData?.otherInputs,
      consolData?.netAssets, consolData?.gainOnBargainPurchase
    ].some(v => Number(v) !== 0 && v !== undefined && v !== null);
    if (hasData) setShowConsoleEntry(true);
  }, [consolData?.nciValue, consolData?.nonControllingAsset, consolData?.investment, consolData?.consolInvestment, consolData?.goodWill, consolData?.otherInputs, consolData?.netAssets, consolData?.gainOnBargainPurchase]);

  // ─── CHANGED: derive initial radio state from existing formData.fsType ───
  const [selectedFsType, setSelectedFsType] = useState(
    formData?.FSType === "consol" ? "existingConsol" : "uploadPreset"
  );

  const addField    = () => setOtherFields((p) => [...p, { id: Date.now(), fieldLabel: "", amount: "" }]);
  const removeField = (id) => setOtherFields((p) => p.filter((f) => f.id !== id));
  const updateField = (id, key, val) => {
    const updated = otherFields.map((f) => f.id === id ? { ...f, [key]: val } : f);
    setOtherFields(updated);
    onChange("addOtherDetails", updated.map(f => ({ description: f.fieldLabel, amount: Number(f.amount) || 0 })));
  };

  useEffect(() => {
    if (formData?.addOtherDetails?.length) {
      setOtherFields(
        formData.addOtherDetails.map((d, i) => ({
          id:         i + 1,
          fieldLabel: d.description || "",
          amount:     d.amount != null ? String(d.amount) : "",
        }))
      );
    }
  }, [formData?.addOtherDetails]);

  // ─── CHANGED: sync radio state when formData.fsType changes from outside ───
  useEffect(() => {
    if (formData?.FSType) {
      setSelectedFsType(formData.FSType === "consol" ? "existingConsol" : "uploadPreset");
    }
  }, [formData?.FSType]);

  return (
    <div style={{
      background: "#fff", border: "1px solid #EAEEED", borderRadius: "14px",
      padding: "24px 28px", display: "flex", flexDirection: "column", gap: "20px",
    }}>
      <div style={{
        marginLeft: "-28px", marginRight: "-28px",
        paddingLeft: "28px", paddingRight: "28px",
        paddingBottom: "16px", fontSize: "18px", fontWeight: "500", color: "#111",
        borderBottom: "1px solid #EAEEED",
      }}>
        Additional Info
      </div>

      {/* ─── CHANGED: Radio buttons + conditional dropdown (mirrors CreateInvestment1) ─── */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px", padding: "10px 0" }}>
        <div style={{ fontWeight: "500", whiteSpace: "nowrap" }}>
          Browse Control Date FS
        </div>
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <label style={{ display: "flex", alignItems: "center", fontWeight: "500", cursor: "pointer" }}>
            <input
              type="radio"
              name="fsTypeSelectionEdit"
              value="uploadPreset"
              checked={selectedFsType === "uploadPreset"}
              onChange={() => {
                setSelectedFsType("uploadPreset");
                onChange("FSType", "standalone");
                onChange("consolID", "");
              }}
              style={{ marginRight: "8px" }}
            />
            Upload Preset
          </label>

          <label style={{ display: "flex", alignItems: "center", fontWeight: "500", cursor: "pointer" }}>
            <input
              type="radio"
              name="fsTypeSelectionEdit"
              value="existingConsol"
              checked={selectedFsType === "existingConsol"}
              onChange={() => {
                setSelectedFsType("existingConsol");
                onChange("FSType", "consol");
                onChange("controlDateFS", "");
              }}
              style={{ marginRight: "8px" }}
            />
            Select Existing Consol FS
          </label>
        </div>
      </div>

      {/* ─── CHANGED: Show project preset dropdown OR consol dropdown based on radio ─── */}
      {selectedFsType === "uploadPreset" && (
        <CustomDropdown
          label=""
          options={projectOptions}
          placeholder="Select Preset"
          value={formData?.controlDateFS}
          fallbackLabel={formData?.controlDateFSName}
          onChange={(v) => onChange("controlDateFS", v)}
          fullWidth
        />
      )}

      {selectedFsType === "existingConsol" && (
        <CustomDropdown
          label=""
          placeholder="Select Existing Consol FS"
          options={(consolList || []).map(c => ({
            label: c.name,
            value: c._id
          }))}
          value={formData?.consolID}
          onChange={(v) => onChange("consolID", v)}
          fullWidth
        />
      )}
      {/* ─── END CHANGED ─── */}

      <div style={{ border: "1px solid #EAEEED", borderRadius: "10px", padding: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "14px" }}>
          <span style={{ fontSize: "14px", fontWeight: "500", color: "#111" }}>Add Other Details</span>
          <button onClick={addField} style={{
            background: "none", border: "none", cursor: "pointer",
            display: "flex", alignItems: "center", gap: "6px",
            color: "#349F6F", fontSize: "16px", fontWeight: "500", padding: 0,
          }}>
            <PlusIcon width={15} height={15} /> Add Field
          </button>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {otherFields.map((f) => (
            <div key={f.id} style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <input
                className={investmentRegisterCss.input} style={{ flex: 2 }}
                placeholder="Type something..."
                value={f.fieldLabel}
                onChange={(e) => updateField(f.id, "fieldLabel", e.target.value)}
              />
              <div className={investmentRegisterCss.inputWrapper} style={{ flex: 1 }}>
                <input
                  className={investmentRegisterCss.input} style={{ paddingRight: "36px" }}
                  placeholder="Enter Amount"
                  value={f.amount}
                  onChange={(e) => updateField(f.id, "amount", e.target.value)}
                />
                <span className={investmentRegisterCss.iconRight}>
                  <img src={rupeeIcon} alt="₹" className={investmentRegisterCss.rupeeIcon} />
                </span>
              </div>
              <button onClick={() => removeField(f.id)} style={{
                background: "none", border: "none", cursor: "pointer",
                padding: "4px", display: "flex", alignItems: "center",
              }}>
                <RemoveIcon />
              </button>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "14px", color: "#111" }}>
        <span>Is the transaction covered as common control transaction?</span>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {["NO", "YES"].map((opt) => (
            <label key={opt} style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer" }}>
              <input
                type="radio" name="commonControl" value={opt}
                checked={(formData?.isCommonControl || "NO") === opt}
                onChange={() => onChange("isCommonControl", opt)}
                style={{ accentColor: "#3AB67D", cursor: "pointer", width: "16px", height: "16px" }}
              />
              {opt}
            </label>
          ))}
        </div>
      </div>

      <div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            type="button"
            onClick={() => setShowConsoleEntry((p) => !p)}
            style={{
              background: "#fff", border: "1px solid #EAEEED", borderRadius: "8px",
              padding: "10px 20px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#111",
            }}
          >
            Create Consol Entry
          </button>
          <button
            type="button"
            onClick={() => setShowConfigModal(true)}
            style={{
              background: "#205a46", border: "1px solid #205a46", borderRadius: "8px",
              padding: "10px 20px", cursor: "pointer", fontSize: "14px", fontWeight: "500", color: "#ffffff",
            }}
          >
            Configure mapping
          </button>
        </div>

        {showConsoleEntry && (
          <div style={{ display: "flex", gap: "20px", marginTop: "12px" }}>
            <motion.div
              initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
              style={{ flex: 1, border: "1px solid #EAEEED", borderRadius: "10px", overflow: "hidden" }}
            >
              <div style={{ padding: "12px 16px", fontSize: "15px", fontWeight: "600", color: "#111111", borderBottom: "1px solid #EAEEED" }}>
                Consol Entry 
              </div>
              {[
                { label: "Non-Controlling Asset", value: consolData.nciValue || 0 },
                { label: "Investments",           value: consolData.investment || 0 },
                { label: "Goodwill",              value: consolData.goodWill || 0 },
                { label: "Other inputs",          value: consolData.otherInputs || 0 },
                { label: "Net Assets",            value: consolData.netAssets || 0 },
                { label: "Gain on bargain purchase", value: consolData.gainOnBargainPurchase || 0 }
              ].map((row, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "12px 16px", fontSize: "14px", color: "#111" }}>
                  <span>{row.label}</span>
                  <span style={{ fontWeight: "400" }}>{formatIndianNumber(row.value) || 0}</span>
                </div>
              ))}
            </motion.div>

            {formData.investmentCurrency && (
              <motion.div
                initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
                style={{ flex: 1, border: "1px solid #EAEEED", borderRadius: "10px", overflow: "hidden" }}
              >
                <div style={{ padding: "12px 16px", fontSize: "15px", fontWeight: "600", color: "#111111", borderBottom: "1px solid #EAEEED" }}>
                  Consol Entry in Subsidiary's Local Currency ({formData.investmentCurrency})
                </div>
                {[
                  { label: "Non-Controlling Asset", value: translatedConsolData.nciValue || 0 },
                  { label: "Investments",           value: translatedConsolData.investment || 0 },
                  { label: "Goodwill",              value: translatedConsolData.goodWill || 0 },
                  { label: "Other inputs",          value: translatedConsolData.otherInputs || 0 },
                  { label: "Net Assets",            value: translatedConsolData.netAssets || 0 },
                  { label: "Gain on bargain purchase", value: translatedConsolData.gainOnBargainPurchase || 0 }
                ].map((row, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "12px 16px", fontSize: "14px", color: "#111" }}>
                    <span>{row.label}</span>
                    <span style={{ fontWeight: "400" }}>{formatIndianNumber(row.value) || 0}</span>
                  </div>
                ))}
              </motion.div>
            )}
          </div>
        )}
      </div>

      <ConsolEntryConfigModal
        isOpen={showConfigModal}
        onClose={() => setShowConfigModal(false)}
        fsType={formData.FSType === "consol" ? "consol" : "standalone"}
        fsId={typeof formData.controlDateFS === 'object' ? (formData.controlDateFS?._id || "") : (formData.controlDateFS || "")}
        consolID={typeof formData.consolID === 'object' ? (formData.consolID?._id || "") : (formData.consolID || "")}
        mappingValue={formData.autoAdjustmentMapping || []}
        onSave={(mapping) => {
          onChange("autoAdjustmentMapping", mapping);
        }}
      />
    </div>
  );
};


const mapApiToForm = (data) => {
  if (!data) return {};
  return {
    investeeCompany:           data.investeeCompanyData?.company_name || data.investeeCompany || "",
    investeeCompanyID:         data.investeeCompanyID || data.investeeCompanyData?._id || "",
    investorCompany:           data.investorCompanyData?.company_name || data.investorCompany || "",
    investorCompanyID:         data.investorCompanyID || data.investorCompanyData?._id || "",
    transactionDate:           data.transactionDate ? dayjs(data.transactionDate).format("DD-MM-YYYY") : "",
    noOfShares:                data.noOfSharesPurchased      != null ? String(data.noOfSharesPurchased)      : (data.noOfShares != null ? String(data.noOfShares) : ""),
    classOfShare:              data.classOfShare             || "",
    purchasePricePerShare:     data.purchasePricePerShare    != null ? String(data.purchasePricePerShare)    : "",
    totalConsideration:        data.totalConsideration       != null ? String(data.totalConsideration)       : "",
    totalSharesOutstanding:    data.totalSharesOutstanding   != null ? String(data.totalSharesOutstanding)   : "",
    purchasedFrom:             data.purchasedFrom            || "",
    costBasisMethod:           data.costBasisMethod          || "",
    cashBankPaid:              data.cashBankPaidUpfront      != null ? String(data.cashBankPaidUpfront)      : (data.cashBankPaid != null ? String(data.cashBankPaid) : ""),
    deferredConsideration:     data.deferredConsideration    != null ? String(data.deferredConsideration)    : "",
    contingentConsideration:   data.contingentConsiderationFV != null ? String(data.contingentConsiderationFV) : (data.contingentConsideration != null ? String(data.contingentConsideration) : ""),
    contingencyDescription:    data.contingencyDescription   || "",
    maxContingentAmount:       data.maxContingentAmount      != null ? String(data.maxContingentAmount)      : "",
    deferredPaymentDate:       data.deferredPaymentDate   && data.deferredPaymentDate   !== "null" ? dayjs(data.deferredPaymentDate).format("DD-MM-YYYY")   : "",
    contingentPaymentDate:     data.contingentPaymentDate && data.contingentPaymentDate !== "null" ? dayjs(data.contingentPaymentDate).format("DD-MM-YYYY") : "",
    transactionCosts:          data.transactionCosts         != null ? String(data.transactionCosts)         : "",

    // Sale related keys
    noOfSharesSold:            data.noOfSharesSold           != null ? String(data.noOfSharesSold)           : "",
    salePricePerShare:         data.salePricePerShare        != null ? String(data.salePricePerShare)        : "",
    totalSaleProceeds:         data.totalSaleProceeds        != null ? String(data.totalSaleProceeds)        : "",
    costOfSharesSold:          data.costOfSharesSold         != null ? String(data.costOfSharesSold)         : "",
    gainOrLossInSale:          data.gainOrLossInSale         != null ? String(data.gainOrLossInSale)         : (data.gainOrLoss != null ? String(data.gainOrLoss) : ""),
    soldTo:                    data.soldTo                   || "",

    // Buyback related keys
    noOfSharesBoughtBack:      data.noOfSharesBoughtBack     != null ? String(data.noOfSharesBoughtBack)     : "",
    buybackPricePerShare:      data.buybackPricePerShare     != null ? String(data.buybackPricePerShare)     : "",
    totalBuybackProceeds:      data.totalBuybackProceeds     != null ? String(data.totalBuybackProceeds)     : "",
    costOfSharesBoughtBack:    data.costOfSharesBoughtBack   != null ? String(data.costOfSharesBoughtBack)   : "",
    gainOrLoss:                data.gainOrLoss               != null ? String(data.gainOrLoss)               : "",
    buybackReference:          data.buybackReference         || "",

    // Rights related keys
    rightsRatio:               data.rightsRatio              || "",
    rightsEntitlement:         data.rightsEntitlement        || "",
    rightsExercised:           data.rightsExercised          || "",
    rightsRenounced:           data.rightsRenounced          || "",
    rightsIssuePrice:          data.rightsIssuePrice         != null ? String(data.rightsIssuePrice)         : "",
    amountPaid:                data.amountPaid               != null ? String(data.amountPaid)               : "",
    totalSharesIssuedInRights: data.totalSharesIssuedInRights != null ? String(data.totalSharesIssuedInRights) : "",

    // Stock Split related keys
    splitRatio:                data.splitRatio               || "",
    oldFaceValue:              data.oldFaceValue             != null ? String(data.oldFaceValue)             : "",
    newFaceValue:              data.newFaceValue             != null ? String(data.newFaceValue)             : "",

    // Bonus related keys
    bonusRatio:                data.bonusRatio               || "",
    bonusSharesReceived:       data.bonusSharesReceived      != null ? String(data.bonusSharesReceived)      : "",
    faceValuePerShare:         data.faceValuePerShare        != null ? String(data.faceValuePerShare)        : "",
    totalSharesAfterBonus:     data.totalSharesAfterBonus    != null ? String(data.totalSharesAfterBonus)    : "",
    recordDate:                data.recordDate && data.recordDate !== "null" ? dayjs(data.recordDate).format("DD-MM-YYYY") : "",

    consolEntry:               data.consolEntry              || {},
    translatedConsolEntry:     data.translatedConsolEntry    || {},
    investmentCurrency:        data.investmentCurrency       || "USD",
    natureOfRelationship:
      data.natureOfRelationship?.includes("Subsidiary")
        ? "Subsidiary"
        : data.natureOfRelationship?.includes("Associate")
        ? "Associate"
        : data.natureOfRelationship?.includes("Joint")
        ? "Joint Venture"
        : data.natureOfRelationship?.includes("Investment")
        ? "Investment"
        : (data.natureOfRelationship || ""),
    // ─── Map browseControlDateFSType → fsType, and both FS fields ───
    FSType:          data.browseControlDateFSType === "consol" ? "consol" : "standalone",
    controlDateFS:   typeof data.browseControlDateFS === 'object' ? (data.browseControlDateFS?._id || "") : (data.browseControlDateFS || ""),
    controlDateFSName: typeof data.browseControlDateFS === 'object' ? (data.browseControlDateFS?.project_name || data.browseControlDateFS?.name || "") : "",
    consolID:        typeof data.browseControlDateConsolID === 'object' 
      ? (data.browseControlDateConsolID?._id || "") 
      : (data.browseControlDateConsolID || (data.browseControlDateFSType === "consol" ? (typeof data.browseControlDateFS === 'object' ? data.browseControlDateFS?._id : data.browseControlDateFS) : "") || ""),
    isCommonControl: (data.isCommonControlTransaction || data.isCommonControl === "YES") ? "YES" : "NO",
    notes:           data.notesRemarks || data.notes || "",
    addOtherDetails: Array.isArray(data.addOtherDetails) ? data.addOtherDetails : [],
    autoAdjustmentMapping: Array.isArray(data.autoAdjustmentMapping) ? data.autoAdjustmentMapping : [],
  };
};

// ─── CHANGED: mapFormToApi now sends browseControlDateFSType + conditional fields ───
const mapFormToApi = (selectedTransaction, formData) => {
  const isSale = selectedTransaction === "Sale of Shares to Third Party";
  const isBuyback = selectedTransaction === "Buyback by Investee from Investor";
  const isRights = selectedTransaction === "Subscription to Rights Issue";
  const isSplit = selectedTransaction === "Stock Split by Investee";
  const isBonus = selectedTransaction === "Bonus Issue by Investee";

  return {
    natureOfTransaction:        selectedTransaction,
    transactionDate:            formData.transactionDate            || "",
    investorCompanyID:          formData.investorCompanyID          || "",
    investeeCompanyID:          formData.investeeCompanyID          || "",
    natureOfRelationship:       formData.natureOfRelationship       || "",
    // ─── CHANGED: send browseControlDateFSType and the correct conditional field ───
    browseControlDateFSType:    formData.FSType === "consol" ? "consol" : "standalone",
    ...(formData.FSType === "consol"
      ? { browseControlDateConsolID: formData.consolID || null }
      : { browseControlDateFS:       formData.controlDateFS || "" }
    ),
    // ─── END CHANGED ───
    autoAdjustmentMapping:     formData.autoAdjustmentMapping || [],
    addOtherDetails:            (formData.addOtherDetails || []).map(({ description, amount }) => ({ description, amount })),
    isCommonControlTransaction: formData.isCommonControl === "YES",
    consolEntry: {
      nonControllingAsset:   formData.consolEntry?.nciValue              || 0,
      investment:            formData.consolEntry?.investment            || 0,
      goodWill:              formData.consolEntry?.goodWill              || 0,
      otherInputs:           formData.consolEntry?.otherInputs           || 0,
      netAssets:             formData.consolEntry?.netAssets             || 0,
      gainOnBargainPurchase: formData.consolEntry?.gainOnBargainPurchase || 0,
    },
    translatedConsolEntry: {
      nonControllingAsset:   formData.translatedConsolEntry?.nciValue              || 0,
      investment:            formData.translatedConsolEntry?.investment            || 0,
      goodWill:              formData.translatedConsolEntry?.goodWill              || 0,
      otherInputs:           formData.translatedConsolEntry?.otherInputs           || 0,
      netAssets:             formData.translatedConsolEntry?.netAssets             || 0,
      gainOnBargainPurchase: formData.translatedConsolEntry?.gainOnBargainPurchase || 0,
    },
    notesRemarks:               formData.notes                      || "",
    investmentCurrency:         formData.investmentCurrency         || "USD",

    ...(!isSale && !isBuyback && !isRights && !isSplit && !isBonus && {
      classOfShare:               formData.classOfShare               || "",
      noOfSharesPurchased:        Number(formData.noOfShares)         || 0,
      purchasePricePerShare:      Number(formData.purchasePricePerShare)      || 0,
      totalConsideration:         Number(formData.totalConsideration)          || 0,
      totalSharesOutstanding:     Number(formData.totalSharesOutstanding)      || 0,
      purchasedFrom:              formData.purchasedFrom              || "",
      costBasisMethod:            formData.costBasisMethod            || "",
      cashBankPaidUpfront:        Number(formData.cashBankPaid)       || 0,
      deferredConsideration:      Number(formData.deferredConsideration)       || 0,
      deferredPaymentDate:        formData.deferredPaymentDate        || "",
      contingentConsiderationFV:  Number(formData.contingentConsideration)     || 0,
      contingencyDescription:     formData.contingencyDescription     || "",
      maxContingentAmount:        Number(formData.maxContingentAmount)          || 0,
      contingentPaymentDate:      formData.contingentPaymentDate      || "",
      transactionCosts:           Number(formData.transactionCosts)   || 0,
    }),

    ...(isSale && {
      noOfSharesSold:      Number(formData.noOfSharesSold) || 0,
      salePricePerShare:   Number(formData.salePricePerShare) || 0,
      totalSaleProceeds:   Number(formData.totalSaleProceeds) || 0,
      costBasisMethod:     formData.costBasisMethod || "",
      costOfSharesSold:    Number(formData.costOfSharesSold) || 0,
      gainOrLossInSale:    Number(formData.gainOrLossInSale) || 0,
      soldTo:              formData.soldTo || "",
    }),

    ...(isBuyback && {
      noOfSharesBoughtBack: Number(formData.noOfSharesBoughtBack) || 0,
      buybackPricePerShare: Number(formData.buybackPricePerShare) || 0,
      totalBuybackProceeds: Number(formData.totalBuybackProceeds) || 0,
      costBasisMethod:      formData.costBasisMethod || "",
      costOfSharesBoughtBack: Number(formData.costOfSharesBoughtBack) || 0,
      gainOrLoss:           Number(formData.gainOrLoss) || 0,
      buybackReference:     formData.buybackReference || "",
    }),

    ...(isRights && {
      rightsRatio:               formData.rightsRatio || "",
      rightsEntitlement:         formData.rightsEntitlement || "",
      rightsExercised:           formData.rightsExercised || "",
      rightsRenounced:           formData.rightsRenounced || "",
      rightsIssuePrice:          Number(formData.rightsIssuePrice) || 0,
      amountPaid:                Number(formData.amountPaid) || 0,
      totalSharesIssuedInRights: formData.totalSharesIssuedInRights || "",
    }),

    ...(isSplit && {
      splitRatio:   formData.splitRatio || "",
      oldFaceValue: Number(formData.oldFaceValue) || 0,
      newFaceValue: Number(formData.newFaceValue) || 0,
    }),

    ...(isBonus && {
      bonusRatio:            formData.bonusRatio || "",
      bonusSharesReceived:   Number(formData.bonusSharesReceived) || 0,
      faceValuePerShare:     Number(formData.faceValuePerShare) || 0,
      totalSharesAfterBonus: formData.totalSharesAfterBonus || "",
      recordDate:            formData.recordDate || null,
    }),
  };
};


const CreateInvestment2 = ({ onBack, tranch, transactionID, investmentID, initialData, timelineData }) => {
  const location = useLocation();
  const history = useHistory();
  const pathArray = location.pathname.split("/");
  const workspace_id = pathArray[2];

  const [formData, setFormData] = useState(() => mapApiToForm(initialData));
  const [selectedTransaction, setSelectedTransaction] = useState(
    initialData?.natureOfTransaction || "Purchase of Shares"
  );
  const [selectedFile, setSelectedFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [registerName, setRegisterName] = useState("");

  const [deletePopup, setDeletePopup] = useState({ isOpen: false, investmentID: null, transactionID: null });
  const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: "" });

  const handleSuccessClose = () => {
    setSuccessPopup({ isOpen: false, message: "" });
    if (onBack) onBack();
  };

  const [fetchedInvestmentData, setFetchedInvestmentData] = useState(null);

  useEffect(() => {
    if (!investmentID) return;

    getInvestmentRegisterForms(investmentID)
      .then((res) => {
        const register = res.data?.investmentRegister;
        if (register?.name) {
          setRegisterName(register.name);
        }
        const investments = register?.investments || [];
        const matched =
          investments.find((inv) => String(inv._id) === String(transactionID)) ||
          investments.find((inv) => String(inv._id) === String(initialData?._id)) ||
          (tranch && typeof tranch === "string" && tranch.toLowerCase().includes("tranch")
            ? investments[parseInt(tranch.replace(/[^0-9]/g, ""), 10) - 1]
            : null) ||
          (investments.length === 1 ? investments[0] : null);

        if (matched) {
          setFetchedInvestmentData(matched);
        }
      })
      .catch((err) => console.error("Failed to fetch register details:", err));
  }, [investmentID, transactionID, initialData?._id, tranch]);

  const [projectOptions, setProjectOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [consolList, setConsolList] = useState([]);

  useEffect(() => {
    if (!workspace_id) return;

    const fetchConsol = async () => {
      try {
        const res = await getAllConsolApi(workspace_id);

        const list =
          res?.data?.consolList ||
          res?.data?.data?.consolList ||
          [];

        setConsolList(list);
      } catch (err) {
        console.log(err);
      }
    };

    fetchConsol();
  }, [workspace_id]);

  useEffect(() => {
    const rawData = fetchedInvestmentData || initialData;
    if (!rawData) return;

    const mapped = mapApiToForm(rawData);

    const validInvestee = companyOptions.find(
      (o) =>
        o.value === rawData.investeeCompanyID ||
        o.label === rawData.investeeCompanyData?.company_name ||
        o.value === rawData.investeeCompany ||
        o.label === rawData.investeeCompany
    );
    const validInvestor = companyOptions.find(
      (o) =>
        o.value === rawData.investorCompanyID ||
        o.label === rawData.investorCompanyData?.company_name ||
        o.value === rawData.investorCompany ||
        o.label === rawData.investorCompany
    );
    const validProject = projectOptions.find(
      (p) => p.value === mapped.controlDateFS || p.label === mapped.controlDateFS
    );

    setFormData((prev) => ({
      ...prev,
      ...mapped,
      investeeCompanyID: validInvestee?.value || rawData.investeeCompanyID || prev.investeeCompanyID || "",
      investorCompanyID: validInvestor?.value || rawData.investorCompanyID || prev.investorCompanyID || "",
      investeeCompany: validInvestee?.label || rawData.investeeCompanyData?.company_name || rawData.investeeCompany || prev.investeeCompany || "",
      investorCompany: validInvestor?.label || rawData.investorCompanyData?.company_name || rawData.investorCompany || prev.investorCompany || "",
      investmentCurrency: validInvestor?.functional || rawData.investmentCurrency || prev.investmentCurrency || "USD",
      controlDateFSName: validProject?.label || mapped.controlDateFSName || prev.controlDateFSName || "",
    }));

    if (rawData.natureOfTransaction) {
      setSelectedTransaction(rawData.natureOfTransaction);
    }
  }, [fetchedInvestmentData, initialData, projectOptions, companyOptions]);

  useEffect(() => {
    if (!investmentID) return;

    const fetchCompanies = async () => {
      try {
        const [linkedRes, allDataRes] = await Promise.all([
          getLinkedCompanies(investmentID),
          GetAllCompanyData()
        ]);
        
        const companies =
          linkedRes.data?.companies ||
          linkedRes.data?.result ||
          linkedRes.data?.data ||
          [];
        const allCompanyData = allDataRes.data?.getAllCompanyData || [];

        const options = companies.map((c) => {
          const fullData = allCompanyData.find(ac => ac._id === c._id);
          return {
            label: c.company_name,
            value: c._id,
            functional: fullData ? fullData.functional : c.functional,
          };
        });
        setCompanyOptions(options);
      } catch (err) {
        console.log("Company fetch error", err);
      }
    };

    fetchCompanies();
  }, [investmentID]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await getProjects();
        const options = res.data.project.map((proj) => ({
          label: proj.project_name,
          value: proj._id,
        }));
        setProjectOptions(options);
      } catch (err) {
        console.log("Project fetch error", err);
      }
    };
    fetchProjects();
  }, []);

  const set = (field) => (val) => setFormData((p) => {
    const newData = { ...p, [field]: val };
    if (field === "investorCompany") {
      const selectedCompany = companyOptions.find(c => c.value === val || c.label === val);
      if (selectedCompany && selectedCompany.functional) {
        newData.investmentCurrency = selectedCompany.functional;
      } else {
        newData.investmentCurrency = "";
      }
    }
    return newData;
  });
  const f   = (field) => formData[field] ?? "";

  const handleTransactionChange = (val) => { setSelectedTransaction(val); };

  const handleSave = async () => {
    if (!formData.investorCompanyID || !formData.investeeCompanyID) {
      setErrorPopup({ isOpen: true, message: "Please select both Investor and Investee company." });
      return;
    }

    const payload = mapFormToApi(selectedTransaction, formData);

    setSaving(true);
    try {
      const res = await editInvestment(investmentID, transactionID, payload);
      console.log("Transaction updated:", res.data);
      setSuccessPopup({ isOpen: true, message: "Changes saved successfully." });
    } catch (err) {
      console.log("Error in saving Edit Investment", err);
      setErrorPopup({ isOpen: true, message: err?.response?.data?.error || err?.response?.data?.message || err.message || "Failed to save changes." });
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteTranch = (investmentID, transactionID) => {
    setDeletePopup({ isOpen: true, investmentID, transactionID });
  };

  const confirmDeleteTranch = async () => {
    const { investmentID, transactionID } = deletePopup;
    setDeletePopup({ isOpen: false, investmentID: null, transactionID: null });
    try {
      await deleteInvestmentTranch(investmentID, transactionID);
      setSuccessPopup({ isOpen: true, message: "Tranch deleted successfully." });
    } catch (error) {
      setErrorPopup({ isOpen: true, message: error?.response?.data?.error || error?.response?.data?.message || error.message || "Failed to delete tranch." });
    }
  };

  const isSale = selectedTransaction === "Sale of Shares to Third Party";

  const renderTransactionFields = () => {
    switch (selectedTransaction) {

      case "Purchase of Shares":
        return (
          <>
            <Row>
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompanyID")}
                fallbackLabel={f("investeeCompany")}
                onChange={(val) => {
                  const comp = companyOptions.find(c => c.value === val);
                  setFormData((p) => ({ ...p, investeeCompanyID: val, investeeCompany: comp?.label || "" }));
                }}
              />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompanyID")}
                fallbackLabel={f("investorCompany")}
                onChange={(val) => {
                  const comp = companyOptions.find(c => c.value === val);
                  setFormData((p) => ({
                    ...p,
                    investorCompanyID: val,
                    investorCompany: comp?.label || "",
                    investmentCurrency: comp?.functional || p.investmentCurrency || ""
                  }));
                }}
              />
              <DateInput label="Transaction Date" value={f("transactionDate")} onChange={set("transactionDate")} />
              
              <TextInput      label="No Of Shares Purchased"   placeholder="Enter No Of Shares"            value={f("noOfShares")}            onChange={set("noOfShares")} />
              <CustomDropdown label="Class Of Share"           options={CLASS_OF_SHARE_OPTIONS}            value={f("classOfShare")}          onChange={set("classOfShare")} placeholder="Select class of share" />
              <AmountInput    label="Purchase Price Per Share"                                              value={f("purchasePricePerShare")} onChange={set("purchasePricePerShare")} />
              
              <TextInput      label="Investment Currency"      placeholder="Type Currency (e.g. USD)"      value={f("investmentCurrency")}  onChange={set("investmentCurrency")} readOnly={true} />
              <AmountInput label="Total Consideration"                                                      value={f("totalConsideration")}     onChange={set("totalConsideration")} />
              <TextInput   label="Total Shares Outstanding"    placeholder="Enter No. of Shares"           value={f("totalSharesOutstanding")} onChange={set("totalSharesOutstanding")} />
              
              <TextInput   label="Purchased From"              placeholder="Select company or type seller name" value={f("purchasedFrom")}   onChange={set("purchasedFrom")} />
              <CustomDropdown label="Cost Basis Method"        options={COST_BASIS_OPTIONS}                value={f("costBasisMethod")}        onChange={set("costBasisMethod")} placeholder="Select method" />
              <AmountInput    label="Cash/Bank Paid (Upfront)"                                             value={f("cashBankPaid")}           onChange={set("cashBankPaid")} />
              
              <AmountInput    label="Deferred Consideration"                                               value={f("deferredConsideration")}  onChange={set("deferredConsideration")} />
              <DateInput   label="Deferred Payment Date"                                                   value={f("deferredPaymentDate")}     onChange={set("deferredPaymentDate")} />
              <AmountInput label="Contingent Consideration (FV)"                                           value={f("contingentConsideration")} onChange={set("contingentConsideration")} />
              
              <TextInput   label="Contingency Description"     placeholder="Type something..."             value={f("contingencyDescription")}  onChange={set("contingencyDescription")} />
              <AmountInput label="Max Contingent Amount"                                                   value={f("maxContingentAmount")}    onChange={set("maxContingentAmount")} />
              <DateInput   label="Contingent Payment Date"                                                 value={f("contingentPaymentDate")}  onChange={set("contingentPaymentDate")} placement="top" />
              
              <AmountInput label="Transaction Costs"                                                       value={f("transactionCosts")}       onChange={set("transactionCosts")} />
            </Row>

            <CustomDropdown
              label="Nature Of Relationship"
              options={RELATIONSHIP_OPTIONS}
              value={f("natureOfRelationship")}
              onChange={set("natureOfRelationship")}
              placeholder="Associate Company"
              fullWidth
            />
          </>
        );

      case "Sale of Shares to Third Party":
        return (
          <>
            <Row>
              <DateInput   label="Transaction Date"                                             value={f("transactionDate")}      onChange={set("transactionDate")} />
              <CustomDropdown
                label="Investor Company"
                options={companyOptions}
                value={f("investorCompanyID")}
                fallbackLabel={f("investorCompany")}
                onChange={(val) => {
                  const comp = companyOptions.find(c => c.value === val);
                  setFormData((p) => ({
                    ...p,
                    investorCompanyID: val,
                    investorCompany: comp?.label || "",
                    investmentCurrency: comp?.functional || p.investmentCurrency || ""
                  }));
                }}
                placeholder="Select Investor"
              />
              <CustomDropdown
                label="Investee Company"
                options={companyOptions}
                value={f("investeeCompanyID")}
                fallbackLabel={f("investeeCompany")}
                onChange={(val) => {
                  const comp = companyOptions.find(c => c.value === val);
                  setFormData((p) => ({
                    ...p,
                    investeeCompanyID: val,
                    investeeCompany: comp?.label || ""
                  }));
                }}
                placeholder="Select Investee"
              />
            </Row>

            <Row>
              <TextInput   label="No Of Shares Sold"        placeholder="Enter No Of Shares"   value={f("noOfSharesSold")}       onChange={set("noOfSharesSold")} />
              <AmountInput label="Sale Price Per Share"                                         value={f("salePricePerShare")}    onChange={set("salePricePerShare")} />
              <AmountInput label="Total Sale Proceeds"                                          value={f("totalSaleProceeds")}   onChange={set("totalSaleProceeds")} />
            </Row>

            <Row>
              <CustomDropdown label="Cost Basis Method"  options={COST_BASIS_OPTIONS}          value={f("costBasisMethod")}      onChange={set("costBasisMethod")} placeholder="Select method" />
              <AmountInput    label="Cost Of Shares Sold"                                       value={f("costOfSharesSold")}    onChange={set("costOfSharesSold")} />
              <AmountInput    label="Gain Or Loss In Sale"                                      value={f("gainOrLossInSale")}    onChange={set("gainOrLossInSale")} />
            </Row>

            <Row2>
              <TextInput label="Sold To" placeholder="Select company or type buyer name"        value={f("soldTo")}              onChange={set("soldTo")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={f("natureOfRelationship")}
                onChange={set("natureOfRelationship")}
                placeholder="Associate Company"
              />
            </Row2>
          </>
        );

      case "Buyback by Investee from Investor":
        return (
          <>
            <Row>
              <DateInput   label="Transaction Date"                                                 value={f("transactionDate")}         onChange={set("transactionDate")} />
              <TextInput   label="Investor Company"     placeholder="Select Investor"              value={f("investorCompany")}         onChange={set("investorCompany")} />
              <TextInput   label="Investee Company"     placeholder="Select Investee"              value={f("investeeCompany")}         onChange={set("investeeCompany")} />
            </Row>

            <Row>
              <TextInput   label="No Of Shares Bought Back" placeholder="Enter No Of Shares"      value={f("noOfSharesBoughtBack")}    onChange={set("noOfSharesBoughtBack")} />
              <AmountInput label="Buyback Price Per Share"                                          value={f("buybackPricePerShare")}   onChange={set("buybackPricePerShare")} />
              <AmountInput label="Total Buyback Proceeds"                                           value={f("totalBuybackProceeds")}  onChange={set("totalBuybackProceeds")} />
            </Row>

            <Row>
              <CustomDropdown label="Cost Basis Method"    options={COST_BASIS_OPTIONS}            value={f("costBasisMethod")}         onChange={set("costBasisMethod")} placeholder="Select method" />
              <AmountInput    label="Cost Of Shares Bought Back"                                   value={f("costOfSharesBoughtBack")} onChange={set("costOfSharesBoughtBack")} />
              <AmountInput    label="Gain Or Loss"                                                 value={f("gainOrLoss")}             onChange={set("gainOrLoss")} />
            </Row>

            <Row2>
              <TextInput label="Buyback Reference / Board Resolution" placeholder="Type something..." value={f("buybackReference")}   onChange={set("buybackReference")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={f("natureOfRelationship")}
                onChange={set("natureOfRelationship")}
                placeholder="Associate Company"
              />
            </Row2>
          </>
        );

      case "Subscription to Rights Issue":
        return (
          <>
            <Row>
              <DateInput   label="Transaction Date"                                                    value={f("transactionDate")}           onChange={set("transactionDate")} />
              <TextInput   label="Investor Company"     placeholder="Select Investor"                 value={f("investorCompany")}           onChange={set("investorCompany")} />
              <TextInput   label="Investee Company"     placeholder="Select Investee"                 value={f("investeeCompany")}           onChange={set("investeeCompany")} />
            </Row>

            <Row>
              <TextInput   label="Rights Ratio"              placeholder="Enter ratio"                value={f("rightsRatio")}               onChange={set("rightsRatio")} />
              <TextInput   label="Rights Entitlement"        placeholder="Enter rights entitlement"   value={f("rightsEntitlement")}         onChange={set("rightsEntitlement")} />
              <TextInput   label="Rights Exercised"          placeholder="Enter rights exercised"     value={f("rightsExercised")}           onChange={set("rightsExercised")} />
            </Row>

            <Row>
              <TextInput   label="Rights Renounced"          placeholder="Enter renounced rights"     value={f("rightsRenounced")}           onChange={set("rightsRenounced")} />
              <AmountInput label="Rights Issue Price"                                                  value={f("rightsIssuePrice")}          onChange={set("rightsIssuePrice")} />
              <AmountInput label="Amount Paid"                                                         value={f("amountPaid")}                onChange={set("amountPaid")} />
            </Row>

            <Row2>
              <TextInput label="Total Shares Issued In Rights (All Shareholders)" placeholder="Enter No Of Shares" value={f("totalSharesIssuedInRights")} onChange={set("totalSharesIssuedInRights")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={f("natureOfRelationship")}
                onChange={set("natureOfRelationship")}
                placeholder="Associate Company"
              />
            </Row2>
          </>
        );

      case "Stock Split by Investee":
        return (
          <>
            <Row>
              <DateInput   label="Transaction Date"                                 value={f("transactionDate")}  onChange={set("transactionDate")} />
              <TextInput   label="Investor Company"  placeholder="Select Investor"  value={f("investorCompany")}  onChange={set("investorCompany")} />
              <TextInput   label="Investee Company"  placeholder="Select Investee"  value={f("investeeCompany")}  onChange={set("investeeCompany")} />
            </Row>

            <Row>
              <TextInput   label="Split Ratio"       placeholder="Enter ratio"      value={f("splitRatio")}       onChange={set("splitRatio")} />
              <AmountInput label="Old Face Value"                                    value={f("oldFaceValue")}     onChange={set("oldFaceValue")} />
              <AmountInput label="New Face Value"                                    value={f("newFaceValue")}     onChange={set("newFaceValue")} />
            </Row>

            <CustomDropdown
              label="Nature Of Relationship"
              options={RELATIONSHIP_OPTIONS}
              value={f("natureOfRelationship")}
              onChange={set("natureOfRelationship")}
              placeholder="Associate Company"
              fullWidth
            />
          </>
        );

      case "Bonus Issue by Investee":
        return (
          <>
            <Row>
              <DateInput   label="Transaction Date"                                    value={f("transactionDate")}      onChange={set("transactionDate")} />
              <TextInput   label="Investor Company"    placeholder="Select Investor"   value={f("investorCompany")}      onChange={set("investorCompany")} />
              <TextInput   label="Investee Company"    placeholder="Select Investee"   value={f("investeeCompany")}      onChange={set("investeeCompany")} />
            </Row>

            <Row>
              <TextInput   label="Bonus Ratio"                  placeholder="Enter ratio e.g. 1:2"  value={f("bonusRatio")}          onChange={set("bonusRatio")} />
              <TextInput   label="No Of Bonus Shares Received"  placeholder="Enter No Of Shares"    value={f("bonusSharesReceived")} onChange={set("bonusSharesReceived")} />
              <AmountInput label="Face Value Per Share"                                               value={f("faceValuePerShare")}  onChange={set("faceValuePerShare")} />
            </Row>

            <Row>
              <TextInput   label="Total Shares After Bonus"  placeholder="Enter No. of Shares"   value={f("totalSharesAfterBonus")} onChange={set("totalSharesAfterBonus")} />
              <DateInput   label="Record Date"                                                     value={f("recordDate")}            onChange={set("recordDate")} />
              <CustomDropdown
                label="Nature Of Relationship"
                options={RELATIONSHIP_OPTIONS}
                value={f("natureOfRelationship")}
                onChange={set("natureOfRelationship")}
                placeholder="Associate Company"
              />
            </Row>
          </>
        );

      default:
        return null;
    }
  };

  const sortedTimeline = timelineData
    ? [...timelineData].sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt) : (a.transactionDate ? new Date(a.transactionDate) : 0);
        const dateB = b.createdAt ? new Date(b.createdAt) : (b.transactionDate ? new Date(b.transactionDate) : 0);
        return dateA - dateB;
      })
    : [];

  const currentIndex = sortedTimeline.findIndex((t) => t._id === transactionID);

  let cumulativePrevShares = 0;
  if (currentIndex > 0) {
    for (let i = 0; i < currentIndex; i++) {
      const item = sortedTimeline[i];
      const purchased = Number(item.noOfSharesPurchased) || 0;
      const sold = Number(item.noOfSharesSold) || 0;
      const boughtBack = Number(item.noOfSharesBoughtBack) || 0;
      const bonus = Number(item.bonusSharesReceived) || 0;
      const rights = Number(item.rightsExercised) || 0;
      const transType = (item.natureOfTransaction || "").toLowerCase();

      if (transType.includes("sale")) {
        cumulativePrevShares -= sold;
      } else if (transType.includes("buyback")) {
        cumulativePrevShares -= boughtBack;
      } else if (transType.includes("bonus")) {
        cumulativePrevShares += bonus;
      } else if (transType.includes("rights")) {
        cumulativePrevShares += rights;
      } else {
        cumulativePrevShares += purchased;
      }
    }
  }

  let currentTransactionDelta = 0;
  const currentTransType = (selectedTransaction || "").toLowerCase();
  if (currentTransType.includes("sale")) {
    currentTransactionDelta = -(Number(formData.noOfSharesSold) || 0);
  } else if (currentTransType.includes("buyback")) {
    currentTransactionDelta = -(Number(formData.noOfSharesBoughtBack) || 0);
  } else if (currentTransType.includes("bonus")) {
    currentTransactionDelta = Number(formData.bonusSharesReceived) || 0;
  } else if (currentTransType.includes("rights")) {
    currentTransactionDelta = Number(formData.rightsExercised) || 0;
  } else {
    currentTransactionDelta = Number(formData.noOfShares) || 0;
  }

  let latestTotalSharesOutstanding = Number(formData.totalSharesOutstanding) || 0;
  if (!latestTotalSharesOutstanding && sortedTimeline.length > 0) {
    for (let i = 0; i < sortedTimeline.length; i++) {
      if (sortedTimeline[i].totalSharesOutstanding) {
        latestTotalSharesOutstanding = Number(sortedTimeline[i].totalSharesOutstanding);
      }
    }
  }

  const prevShares = cumulativePrevShares;
  const currentShares = Math.max(0, cumulativePrevShares + currentTransactionDelta);
  const sharesDiff = currentTransactionDelta;
  const totalShares = latestTotalSharesOutstanding;
  const prevOwnership = totalShares > 0 ? ((prevShares / totalShares) * 100).toFixed(2) : "0.00";
  const currentOwnership = totalShares > 0 ? ((currentShares / totalShares) * 100).toFixed(2) : "0.00";
  const percentDiff = (Number(currentOwnership) - Number(prevOwnership)).toFixed(2);

  const getRelationshipStatus = (percentage) => {
    const value = Number(percentage);
    if (value <= 20) return "Investment";
    if (value > 20 && value < 50) return "Associate";
    if (value === 50) return "Joint Venture";
    if (value > 50) return "Subsidiary";
    return "Investment";
  };

  useEffect(() => {
    if (Number(currentOwnership) > 0) {
      const autoStatus = getRelationshipStatus(currentOwnership);
      setFormData((prev) => {
        if (!prev.natureOfRelationship) {
          return { ...prev, natureOfRelationship: autoStatus };
        }
        return prev;
      });
    }
  }, [currentOwnership]);

  const relationship = formData.natureOfRelationship || getRelationshipStatus(currentOwnership);

  return (
    <div style={{
      position: "fixed",
      top: 0, left: "300px", right: 0, bottom: 0,
      background: "#F5F8F7",
      zIndex: 1000,
      overflowY: "auto",
      padding: "12px 12px",
      paddingBottom: "20px",
    }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        marginBottom: "20px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "14px" }}>
          <span style={{ cursor: "pointer", display: "flex", alignItems: "center" }} onClick={onBack}>
            <LeftArrowIcon height={12} style={{ marginBottom: "2px", marginRight: "6px" }} />
          </span>
          <span style={{ color: "#4D6D64", fontWeight: "500", cursor: "pointer" }} onClick={() => history.push(`/detailsIR/${workspace_id}`)}>Investments</span>
          <span style={{ display: "flex", alignItems: "center", margin: "0 4px" }}>
            <DotIcon />
          </span>
          <span style={{ color: "#4D6D64", fontWeight: "500", cursor: "pointer" }} onClick={onBack}>Investment Timeline</span>
          <span style={{ display: "flex", alignItems: "center", margin: "0 4px" }}>
            <DotIcon />
          </span>
          <span style={{ color: "#111", fontWeight: "600" }}>{tranch ? tranch : "TRANCH 1"}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {transactionID && (
            <span
              style={{ color: "#E30000", fontSize: "14px", fontWeight: "500", cursor: "pointer" }}
              onClick={() => handleDeleteTranch(investmentID, transactionID)}
            >
              Delete Tranch
            </span>
          )}
          <Button
            btnColor={buttoncss.primary}
            label={saving ? "Saving…" : transactionID ? "Save Changes" : "Create"}
            onClick={handleSave}
            disabled={saving}
          />
        </div>
      </div>

      <div>
        <Section>
          <CustomDropdown
            label="Nature Of Transaction"
            options={NATURE_OPTIONS}
            value={selectedTransaction}
            onChange={handleTransactionChange}
            placeholder="Select transaction type"
            fullWidth
          />
          {renderTransactionFields()}
        </Section>

        <HoldingStatus
          prevShares={prevShares}
          prevOwnership={prevOwnership}
          currentShares={currentShares}
          currentOwnership={currentOwnership}
          sharesDiff={sharesDiff}
          percentDiff={percentDiff}
          relationship={relationship}
        />

        {/* ─── CHANGED: pass consolList into AdditionalInfo ─── */}
        {(selectedTransaction === "Purchase of Shares" || isSale) && (
          <AdditionalInfo
            formData={formData}
            projectOptions={projectOptions}
            consolList={consolList}
            onChange={(field, val) => setFormData((p) => ({ ...p, [field]: val }))}
          />
        )}

        {(selectedTransaction === "Purchase of Shares" || isSale) && (
          <div style={{ borderRadius: "14px", padding: "24px 10px", marginTop: "16px" }}>
            <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 8 }}>Attach Valuation Report</label>
            <div
              className={investmentRegisterCss.dragBox}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => { e.preventDefault(); const file = e.dataTransfer.files[0]; if (file) setSelectedFile(file); }}
              onClick={() => document.getElementById("ci2FileInput")?.click()}
            >
              <div>Drag and drop your file here</div>
              <input id="ci2FileInput" type="file" accept=".pdf,.txt,.csv,.xls,.xlsx,.doc,.docx" style={{ display: "none" }}
                onChange={(e) => { const file = e.target.files[0]; if (file) setSelectedFile(file); }} />
            </div>
            {selectedFile && (
              <div style={{ marginTop: "12px", border: "1px solid #EAEEED", borderRadius: "8px", padding: "10px 14px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: "14px", color: "#205a46", fontWeight: "500", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "80%" }}>{selectedFile.name}</span>
                <button onClick={() => setSelectedFile(null)} style={{ background: "none", border: "none", cursor: "pointer", color: "#8FAAA3", fontSize: "16px" }}>✕</button>
              </div>
            )}
          </div>
        )}

        <div style={{ padding: "24px 10px" }}>
          <label className={investmentRegisterCss.label} style={{ display: "block", marginBottom: 6 }}>Notes / Remarks</label>
          <textarea
            className={investmentRegisterCss.input}
            placeholder="Placeholder text"
            value={f("notes")}
            onChange={(e) => set("notes")(e.target.value)}
            rows={4}
            style={{ resize: "vertical", paddingTop: "10px", minHeight: "80px" }}
          />
        </div>
        <DeletePopup
          isOpen={deletePopup.isOpen}
          onCancel={() => setDeletePopup({ isOpen: false, investmentID: null, transactionID: null })}
          onConfirm={confirmDeleteTranch}
        />
        <SuccessPopup
          isOpen={successPopup.isOpen}
          message={successPopup.message}
          onClose={handleSuccessClose}
        />
        <ErrorPopup
          isOpen={errorPopup.isOpen}
          message={errorPopup.message}
          onClose={() => setErrorPopup({ isOpen: false, message: "" })}
        />
      </div>
    </div>
  );
};

export default CreateInvestment2;